import { SquareDotLoadingIndicator } from '@joor/design-system'

import { Container } from './Common.ui'

export function LoadingOverlay() {
  return (
    <Container>
      <SquareDotLoadingIndicator testId="loading-overlay-loader" />
    </Container>
  )
}
